export enum LocationCreateType {
    CreateBuilding = 'CreateBuilding',
    AddSection = 'AddSection',
    AddPen = 'AddPen'
}
